import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from "../../services/login/login.service";
import { LoggedinGuard } from '../../guards/loggedin.guard';
import { SyncGuard } from '../../guards/sync.guard';
import { TokenControlService } from '../../services/state/tokenControl.service';
import { WelcomeService } from '../../services/welcome/welcome.service';
import { RecaptchaV3Service } from "../../services/recaptcha-v3/recaptcha-v3.service";
import { ConfigurationService } from '../../services/configuration/configuration.service';
import { ConfigurationControlService } from '../../services/configuration/configurationControl.service';
import { ConfiguracionDTO } from '../../model/configuracion.dto';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Session } from '../../model/session';
import { Combo } from '../../model/combo';
import { CodResp } from '../../constants/codigosMensajes';
import { Examen } from '../../model/examen';
import { RoutingValidationService } from "../../services/routingValidation/routing-validation.service";
import { WhiteListDTO } from '../../model/witheList.dto';
import { ESTADO_SESSION_INFO } from '../../model/estadoSessionInfo';
import { LogElectronService } from '../../services/logElectron/log-electron.service';
import { LOG_EVENT, LOG_LEVEL } from '../../model/eLogElectron';
import { Mask, MaskService } from '../../services/mask/mask.service';
import { RecuperarInfoService } from '../../services/recuperarInfo/recuperar-info.service';



// declare var grecaptcha: any;
declare var $: any;
// declare var captchaRef: any;

@Component({
  selector: 'app-login-pre-icfes',
  templateUrl: './login-pre-icfes.component.html',
  styleUrls: ['./login-pre-icfes.component.css']
})

// Controlador de pagina de Login Demo
export class LoginPreIcfesComponent implements OnInit {

  // Flag que se encarga de mostrar el spinner mientras se hace el login
  public loading = false;

  // Mensaje de error general para problemas en el login
  public messageError: string;

  // lenguaje del navegador
  public defaultLanguage: string;

  // Indica si se presento un error en el login
  public errorLogin: boolean;

  /**Bandera para mostrar el boton login */
  public showLogin: Boolean;

  // listado de los combos activos para demo
  public combosDemo: Combo[];

  // Grupo de validaciones
  public loginPreIcfesForm: UntypedFormGroup;

  // usuario que realiza el demo
  public user: string;

  // contraseña del usuario demo
  public password: string;

  // identificador del combo seleccionado para realizar el demo
  public idCombo: Combo;

  // Documento completo
  public docCompleto: string;

  // Lista que contiene los tipos de documento.
  public listaTipoDocumentos: any;

  //Listado de examenes activos para pre icfes
  public listaExamenes: Examen[];

  //valor del examen
  public idExamen: Examen;

  public showCombos: Boolean;

  constructor(private _router: Router,
    private _recuperarInfoServices: RecuperarInfoService,
    private _loginService: LoginService,
    private _tokenController: TokenControlService,
    private _loggedinGuard: LoggedinGuard,
    private _syncGuard: SyncGuard,
    private _welcomeDataService: WelcomeService,
    private _translateService: TranslateService,
    private _configurationService: ConfigurationService,
    public _configurationControlService: ConfigurationControlService,
    private _recaptchaService: RecaptchaV3Service,
    private formBuilder: UntypedFormBuilder,
    private _logElectronService: LogElectronService,
    private _routingValidationService: RoutingValidationService,
    private _maskService: MaskService
  ) {
    this.errorLogin = false;
    this.messageError = '';
    this.getNavigatorLang();
    this.getPublicIp();
    this._configurationControlService.sessionInfo = new Session('', '', new Date(), null, null);
    this._translateService.addLangs(['es', 'en']);
    this._translateService.use(this.defaultLanguage);
    this.user = '';
    this.password = '';
    this.docCompleto = '';
    // this.listaTipoDocumentos = [
    //   { tipo: 'CC', valor: 'Cédula de ciudadanía' },
    //   { tipo: 'CE', valor: 'Cédula de extranjería' },
    //   { tipo: 'CR', valor: 'Contraseña registraduría' },
    //   { tipo: 'NES', valor: 'Número identificación Secretaría de educación' },
    //   { tipo: 'PC', valor: 'Pasaporte colombiano' },
    //   { tipo: 'PE', valor: 'Pasaporte extranjero' },
    //   { tipo: 'PEP', valor: 'Permiso especial de permanecencia' },
    //   { tipo: 'TI', valor: 'Tarjeta de identidad' }];
    this._configurationControlService.esDemo = true;
    this.showCombos = false;
    this.listaExamenes = [];
    this.combosDemo = [];
  }

  ngOnInit() {
    this._configurationService.inhabilitarBotonAtras();
    $("body").css("background-image", "url(/src/app/resources/img/demoPreicfes.png)");
    $("body").css("background-repeat", "repeat");
    this.showLogin = true;
    var is_chrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
    if (!is_chrome) {
      this.showLogin = false;
      alert("Este explorador no está soportado, por favor acceda desde Google Chrome.")
    }
    this.loadExamenes();
    this.listarDocumentos();
    this.loadForm(null);
    this._maskService.setMask(Mask.basicMask, false);
  }

  public goToLogin(): void {
    this._router.navigate(['/login']);
    this._configurationControlService.ambiente = '';
  }

  public listarDocumentos() {
    this._recuperarInfoServices.validarListaDocumentos().then(
      res => {
        this.listaTipoDocumentos = res;
      }
    )
  }

  public loadForm(examen) {
    if (examen == undefined || examen == null) {
      examen = ""
    }
    let documento = "";

    this.loginPreIcfesForm = this.formBuilder.group({
      examen: [examen, [Validators.required]],
      tipoDocumento: [documento, [Validators.required]],
      numDocumento: ['', [Validators.required, Validators.maxLength(15), Validators.minLength(5), Validators.pattern(/^[a-zA-Z0-9]*$/)]]
    });
  }

  /*Se encarga de consultar el idioma del navegador*/
  private getNavigatorLang() {
    this.defaultLanguage = this._translateService.getBrowserLang();
    if (this.defaultLanguage !== 'es' && this.defaultLanguage !== 'en') {
      this.defaultLanguage = 'es';
    }
  }

  /*Metodo encargado de consultar la ip del cliente para almacenarla
    en el objeto respuesta*/
  public getPublicIp() {
    let self = this;
    this._loginService.getIp().then(res => {
      self._configurationControlService.publicIp = res['ip'];
    })
  }

  // Permite cargar los diferentes combos asignados para demo
  public loadExamenes(): Promise<string> {
    return new Promise(resolve => {
      let self = this;
      this._configurationService.getExamenes().then((res: Examen[]) => {
        self.listaExamenes = res;
        if (res) {
          if (self.listaExamenes.length == 1) {
            self.loadDefault("Examen0");
          }
          resolve("OK");
        } else {
          resolve(null);
        }
      });
    });
  }

  /** Metodo encargado de setear pro defecto el primer examen  */
  public loadDefault(idComponente: string) {
    let self = this;
    setTimeout(function () {
      $("#" + idComponente).attr("selected", "true");
      self.loginPreIcfesForm.value.examen = self.listaExamenes[0];
      self.loadPruebas();
    }, 10);
  }

  //Método que se encarga de cargar las pruebas de acuerdo al examen seleccionado.
  public loadPruebas() {
    this.combosDemo = null;
    let examen = this.loginPreIcfesForm.value.examen
    this._configurationControlService.pruebasDisponibles = examen.pruebaExamen;
    this.loadForm(examen);

    if (examen != undefined && examen != "") {
      this.loginPreIcfesForm.value.examen = examen;
      this.combosDemo = examen.pruebaExamen;
    } else {
      this.loadForm(examen);
    }
  }

  /** Método encargado de ejecutar el recaptcha y solicitar el score */
  public recaptcha(myIp): void {
    this.loading = true;
    let self = this;
    this._recaptchaService.execute('login', this._configurationControlService.publicIp).then(result => {
      let whiteListDTO = new WhiteListDTO(self._configurationControlService.publicIp, result);

      self._loginService.verifyWhiteList(whiteListDTO).then(res => {
        if (res == "true") {
          var tDoc = self.loginPreIcfesForm.get('tipoDocumento').value;
          var infoT = self.loginPreIcfesForm.get('numDocumento').value;
          let examen = self.loginPreIcfesForm.value.examen
          self._configurationControlService.pruebasDisponibles = examen.pruebaExamen;
          self._configurationControlService.documento = tDoc + infoT;
          self._configurationControlService.examConfiguration = new ConfiguracionDTO('1', 'NINGUNO', false, false, false, false, false, 'es', false, false, false, false, false, false, null, false, false, false, false, false, false, false, false, false, false);
          self._router.navigate(['/welcomePreIcfes']);
        } else {
          this.errorRecaptcha();
        }
      })
    });
  }

  // Encargado de la creación de usuario demo, previo al Login
  public preLogin(): void {
    this.loading = true;
    let self = this;
    self.idExamen = this.loginPreIcfesForm.get('examen').value;
    self.idCombo = this.loginPreIcfesForm.get('prueba').value;
    var tDoc = this.loginPreIcfesForm.get('tipoDocumento').value;
    var infoT = this.loginPreIcfesForm.get('numDocumento').value;
    self.docCompleto = tDoc + infoT;
    self.loadDemoUser();
  }

  // encargado de realizar el proceso de autenticación
  public login() {
    let self = this;
    if (this.validateCredentials()) {
      this._loginService.login(this.user, this.password, self._configurationControlService.publicIp).then(result => {
        if (result == null) {
          this.errorAutenticate();
          return;
        }

        if (result.estado === 1) {
          self._loggedinGuard.loggedIn = true;
          self._tokenController.token = result;

          if (result.userType === 2) {
            self._syncGuard.canSync = true;
          }
          self._loginService.saveToken(result);
          let route = null;
          if (result.userType === 1 || result.userType === 5) {
            route = '/welcome';
            self._loginService.loadWelcomeInfo(
              self._tokenController.token.credentialId,
              self._tokenController.token.token,
              self._tokenController.token.tokenId,
              self._configurationControlService.examConfiguration.multiplesesion)
              .then(res => {
                self._welcomeDataService.data = res;
                let idCombo = self._welcomeDataService.data.idCombo;
                self._configurationService.loadExamConfiguration(idCombo,
                  self._tokenController.token.token,
                  self._tokenController.token.tokenId)
                  .then(data => {
                    self._configurationControlService.examConfiguration = data;
                    self.loading = false;
                    self._configurationControlService.sessionInfo.ipPublica = self._configurationControlService.publicIp;
                    self._configurationControlService.sessionInfo.fechaIngreso = new Date();
                    self._configurationControlService.sessionInfo.credencial = this._tokenController.token.credentialId;
                    try {
                      self._logElectronService.saveLog(LOG_LEVEL.INFO, LOG_EVENT.E_LOAD, `credentialId=${self._tokenController.token.credentialId}`)
                    } catch (error) { }
                    self._configurationControlService.sessionInfo.sesion = null;
                    self._loginService.saveSessionInfo(self._tokenController.getTokenValue(), self._tokenController.token.tokenId, ESTADO_SESSION_INFO.LOGIN);
                    self._configurationControlService.credencial = this._tokenController.token.credentialId;
                    self._configurationControlService.idPrueba = self._welcomeDataService.data.sessions[0].subjects[0].subjectCode;
                    self._router.navigate(['/welcome']);
                  });
              });
          } else if (result.userType === 2) {
            self._configurationControlService.examConfiguration = new ConfiguracionDTO('1', 'NINGUNO', false, false, false, false, false, 'es', false, false, false, false, false, false, null, false, false, false, false, false, false, false, false, false, false);
            self._syncGuard.canSync = true;
            self._router.navigate(['/sync']);
          } else if (result.userType === 3) {
            self._configurationControlService.examConfiguration = new ConfiguracionDTO('1', 'NINGUNO', false, false, false, false, false, 'es', false, false, false, false, false, false, null, false, false, false, false, false, false, false, false, false, false);
            self._router.navigate(['/uploadFiles']);
          }
        } else {
          if (result == null || result.credentialId == null) {
            self.messageError = result.message;
          } else {
            self.messageError = result.message;
          }
          self.loading = false;
          self.errorLogin = true;
          // this._captchaService.reloadCaptcha();
        }
      }, err => {
        self.messageError = CodResp[26].nombre;
        self.loading = false;
        self.errorLogin = true;
        // this._captchaService.reloadCaptcha();
      });
    } else {
      this.errorAutenticate();
    }
  }

  public errorAutenticate() {
    let self = this;
    this._translateService.get('mensaje.usuario.no.valido')
      .subscribe((res: string) => {
        self.messageError = res;
      });
    // this._captchaService.reloadCaptcha();
    self.loading = false;
    self.errorLogin = true;
  }

  // Se encarga de validar que las credenciales no sean nulas
  public validateCredentials(): boolean {
    let valid = true;
    if (!this.user || this.user.trim() === '') {
      valid = false;
    }
    if (!this.password || this.password.trim() === '') {
      valid = false;
    }
    return valid;
  }

  // Encargado de consultar un usuario demo y que sea asociado al combo seleccionado por el usuario
  public loadDemoUser(): Promise<string> {
    return new Promise(resolve => {
      let self = this;
      this._configurationService.getDemoUser(self.idCombo.idCombo.toString(), self.docCompleto).then((res: string) => {
        this.user = res;
        this.password = res;
        console.log('usuario demo: ' + this.user);
        if (res) {
          self.login();
          resolve('OK');
        } else {
          resolve(null);
        }
      });
    });
  }

  /** Método encargado de manejar el error en el recaptcha */
  public errorRecaptcha() {
    let self = this;
    this._translateService.get('mensaje.usuario.no.humano')
      .subscribe((res: string) => {
        self.messageError = res;
      });
    self.loading = false;
    self.errorLogin = true;
  }
}
